import DraftOrderShowPage from '../../components/pages/draft_orders/DraftOrderShowPage.vue'
export default {
  components: { DraftOrderShowPage }
}
